/** @file Names that are used within the form component system. */
/** String used as the name, the data-cy value, and the class selector of the component. */
export const nameRoot = 'cg-form-root';
/** @inheritdoc */
export const nameField = 'cg-form-field';
/** @inheritdoc */
export const nameLabel = 'cg-form-label';
/** @inheritdoc */
export const nameControl = 'cg-form-control';
/** @inheritdoc */
export const nameToggle = 'cg-form-toggle';
/** @inheritdoc */
export const nameSelect = 'cg-form-select';
/** @inheritdoc */
export const nameDescription = 'cg-form-description';
/** @inheritdoc */
export const nameMessage = 'cg-form-message';
/** @inheritdoc */
export const nameRadioButtons = 'cg-form-field-radio-buttons';
/** @inheritdoc */
export const nameCheckboxes = 'cg-form-field-checkboxes';
/** @inheritdoc */
export const nameFieldset = 'cg-form-fieldset';
/** @inheritdoc */
export const nameOption = 'cg-form-option';
/** @inheritdoc */
export const nameValidationMessage = 'cg-form-field-validation-msg';
